import { atom } from 'nanostores'

import { AccidentAtlasApiResponse } from '@components/accidentAtlas/types/api'
import { AccidentAtlasLoadStatus } from '@components/accidentAtlas/types/view'
import { fetchAccidentAtlasData } from '@services/api/accidentAtlas'

export const $accidentAtlasRaw = atom<AccidentAtlasApiResponse | null>(null)
export const $accidentAtlasStatus = atom<AccidentAtlasLoadStatus>('idle')
export const $accidentAtlasError = atom<string | null>(null)

// Promise to store the inflight load request
let inflightLoad: Promise<AccidentAtlasApiResponse | null> | null = null

// Fetch the data from the API
export async function loadAccidentAtlasData(
  force = false
): Promise<AccidentAtlasApiResponse | null> {
  if (!force) {
    const memoryData = $accidentAtlasRaw.get()
    if (memoryData) {
      $accidentAtlasStatus.set('ready')
      return memoryData
    }
  }

  if (inflightLoad) {
    return inflightLoad
  }

  $accidentAtlasStatus.set('loading')
  $accidentAtlasError.set(null)

  inflightLoad = fetchAccidentAtlasData()
    .then((data) => {
      $accidentAtlasRaw.set(data)
      $accidentAtlasStatus.set('ready')
      return data
    })
    .catch((error: unknown) => {
      const message =
        error instanceof Error ? error.message : 'Unbekannter Fehler'
      $accidentAtlasStatus.set('error')
      $accidentAtlasError.set(message)
      return null
    })
    .finally(() => {
      inflightLoad = null
    })

  return inflightLoad
}
